import type { Unsubscribe } from '../types'

type Handler = () => void

const handlers = new Set<Handler>()

/**
 * «Клавиатура доехала»: геометрия устоялась и переменные вьюпорта уже опубликованы на `<html>`.
 *
 * Нужен тем, кто меряет раскладку руками, — прежде всего скроллу к сфокусированному полю внутри
 * шторки (`shared/ui/BottomSheet`). Раньше он ждал первый `resize` visualViewport'а и считал
 * положение поля посреди анимации клавиатуры: высота шторки в этот момент ещё старая, и поле
 * либо не доезжало, либо уезжало лишнего. Событие вместо `visualViewport` заодно убирает
 * платформенное API из компонента (правило 6).
 */
export function onKeyboardSettled(handler: Handler): Unsubscribe {
  handlers.add(handler)

  return () => {
    handlers.delete(handler)
  }
}

/** Зовёт только `ViewportRuntime` — сразу после публикации новой геометрии клавиатуры. */
export function emitKeyboardSettled(): void {
  for (const handler of [...handlers]) handler()
}
